import { useRoutes } from 'react-router-dom';
import { Suspense } from "react";
import { CircularProgress, Box } from "@mui/material";

// routes
import MainRoutes from './mainRoutes';
import FrontRoutes from './frontRoutes';
import AuthenticationRoutes from './authenticationRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function RouteManager() {
    return <Suspense
    fallback={
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    }
  > {useRoutes([FrontRoutes, AuthenticationRoutes, MainRoutes])}
    </Suspense>
}
